// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlueInputFileContainer {
    padding: 1em;
    text-align: center;
}

.BlueInputFile {
    color: var(--DarkBlue);
    padding: 1em;
    margin: auto;
    /* border: 1px solid var(--DarkBlueButtonBackground); */
    border-radius: 5px;
}

.BlueInputFileLabel {
    color: var(--DarkBlueButtonBackground);
}

.BlueInputFile::-webkit-file-upload-button {
    display: inline-block;
    background-color: var(--DarkBlueButtonBackground);
    border-radius: 4px;
    border: none;
    color: white;
    margin: 4px 1px;
    padding: 8px;
    min-width: 70px;
    font-family: var(--googleFont);
    cursor: pointer;
    width: 100%;
}

.BlueInputFile::-webkit-file-text {
    color: green;
    border: 1px solid black;
}

@media only screen and (max-width: 890px) {
    .BlueInputFile {
        border: none;
        transform: scale(0.8);
    }
}

@media screen and (max-width: 320px) {
    .BlueInputFileContainer {
        transform: scale(0.8);
    }

    .BlueInputFile {
        border: none;
        transform: scale(0.8);
        padding-right: 2em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/BlueInputFile/BlueInputFile.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,uDAAuD;IACvD,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI;QACI,YAAY;QACZ,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,qBAAqB;QACrB,kBAAkB;IACtB;AACJ","sourcesContent":[".BlueInputFileContainer {\n    padding: 1em;\n    text-align: center;\n}\n\n.BlueInputFile {\n    color: var(--DarkBlue);\n    padding: 1em;\n    margin: auto;\n    /* border: 1px solid var(--DarkBlueButtonBackground); */\n    border-radius: 5px;\n}\n\n.BlueInputFileLabel {\n    color: var(--DarkBlueButtonBackground);\n}\n\n.BlueInputFile::-webkit-file-upload-button {\n    display: inline-block;\n    background-color: var(--DarkBlueButtonBackground);\n    border-radius: 4px;\n    border: none;\n    color: white;\n    margin: 4px 1px;\n    padding: 8px;\n    min-width: 70px;\n    font-family: var(--googleFont);\n    cursor: pointer;\n    width: 100%;\n}\n\n.BlueInputFile::-webkit-file-text {\n    color: green;\n    border: 1px solid black;\n}\n\n@media only screen and (max-width: 890px) {\n    .BlueInputFile {\n        border: none;\n        transform: scale(0.8);\n    }\n}\n\n@media screen and (max-width: 320px) {\n    .BlueInputFileContainer {\n        transform: scale(0.8);\n    }\n\n    .BlueInputFile {\n        border: none;\n        transform: scale(0.8);\n        padding-right: 2em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
